import React from "react";
import styles from "./OnboardingStrategy.module.css";
import { cleanLines, stripBoldTitle } from "./utils";

const parseShopifySnapshot = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  return { body: lines.join(" ").trim() };
};

const ShopifySyncSnapshot = ({ markdown = "" }) => {
  const { body } = parseShopifySnapshot(markdown);
  if (!body) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Connect Shopify</h3>
      <div className={styles.card}>
        <div className={styles.sectionHeader}>
          {/* <span>SYNC</span>
          <span className={styles.sectionLabel}>Sync Overview</span> */}
        </div>
        <p className={styles.paragraph}>{body}</p>
      </div>
      {/* <div className={styles.summaryCard}>
        <h4 className={styles.summaryTitle}>What Does This Mean?</h4>
        <p className={styles.summaryText}>
          Establishing foundational telemetry through Shopify sync enables accurate tracking and informed marketing strategies.
        </p>
      </div> */}
    </div>
  );
};

export default ShopifySyncSnapshot;
